<template functional>
  <div class="price-tip">
    <template v-if="parent.cruiseType === 1">
      <p v-if="props.data.adult_price">
        ￥{{ props.data.adult_price }} 成人价格
      </p>
      <p v-if="props.data.child_price">
        ￥{{ props.data.child_price }} 儿童价格
      </p>
      <p v-if="props.data.adult_bed_price">
        ￥{{ props.data.adult_bed_price }} 成人加床价格
      </p>
      <p v-if="props.data.diff_room_price">
        ￥{{ props.data.diff_room_price }} 单房差价格
      </p>
      <p v-if="props.data.child_bed_price">
        ￥{{ props.data.child_bed_price }} 儿童加床价格
      </p>
      <p v-if="props.data.child_no_bed_price">
        ￥{{ props.data.child_no_bed_price }} 儿童不占床价格
      </p>
    </template>
    <template v-else>
      <p v-if="props.data.adult_price">
        ￥{{ props.data.adult_price }} 1/2价格
      </p>
      <p v-if="props.data.adult34_price">
        ￥{{ props.data.adult34_price }} 3/4成人价格
      </p>
      <p v-if="props.data.child34_price">
        ￥{{ props.data.child34_price }} 3/4儿童价格
      </p>
      <p v-if="props.data.diff_room_price">
        ￥{{ props.data.diff_room_price }} 单房差价格
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name: "PriceTip",
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style>

</style>
